export const SET_STORE_DETAILS = 'SET_STORE_DETAILS';
